import script from "./BeneficiaryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BeneficiaryModal.vue?vue&type=script&setup=true&lang=js"

import "./BeneficiaryModal.vue?vue&type=style&index=0&id=4c6b5d72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6b5d72"]])

export default __exports__